/* import __COLOCATED_TEMPLATE__ from './insurance-card-upload.hbs'; */
import RequestInformationSharedInsuranceCardField from 'client-portal/components/request/information/shared/insurance-card-field';
import styles from './insurance-card-upload.module.scss';

export default class RequestPrescreenerQuestionTypesSpecializedInputsInsuranceCardUpload extends RequestInformationSharedInsuranceCardField {
  styles = styles;
}
